// Continuous printed numbering for KET (A2 Key) exam papers.
//
// The DB stores order_index per exercise (0-based, examples first), but the
// original paper numbers questions continuously across the whole paper
// (e.g. Listening: P1=1-5 ... P5=21-25; Reading & Writing: P4=21-27, P5=28-35 ...).
// Each exercise's content_data.instruction contains its printed range
// ("For questions 16–20", "conversations 11-15"), which we parse to recover
// the printed start number for the exercise.

// Word-anchored range, e.g. "questions 16–20", "conversations 11-15",
// "(questions 16-20)". Dash may be -, – or —.
const ANCHORED_RANGE_RE = /(?:questions?|conversations?)\s*\(?\s*(\d+)\s*[-–—]\s*\d+/i;
// Generic numeric range fallback, e.g. "each space (41–50)".
const GENERIC_RANGE_RE = /(\d+)\s*[-–—]\s*(\d+)/;

// Printed start number parsed from the instruction ("questions 16-20" -> 16). Fallback 1.
export function ketPrintedStart(exerciseData) {
  const instruction = (exerciseData && exerciseData.content_data && exerciseData.content_data.instruction) || '';
  const anchored = instruction.match(ANCHORED_RANGE_RE);
  if (anchored) return parseInt(anchored[1], 10);
  const generic = instruction.match(GENERIC_RANGE_RE);
  if (generic && parseInt(generic[2], 10) >= parseInt(generic[1], 10)) {
    return parseInt(generic[1], 10);
  }
  return 1;
}

// Map question.id -> printed number for SCORED questions (points > 0),
// sorted by order_index; examples (points === 0) get null (they are labeled
// "Ví dụ", not numbered).
export function ketNumberMap(exerciseData) {
  const map = {};
  const questions = (exerciseData && exerciseData.questions) || [];
  const sorted = [...questions].sort((a, b) => a.order_index - b.order_index);
  let next = ketPrintedStart(exerciseData);
  sorted.forEach(q => {
    if (q.points > 0) {
      map[q.id] = next;
      next += 1;
    } else {
      map[q.id] = null;
    }
  });
  return map;
}
